import { V2LvdLegislationBriefing } from '../../components/V2LvdLegislationBriefing'
import { V2ProductRegulationPageShell } from './V2ProductRegulationPageShell'

type V2ProductLvdRegulationPageProps = {
  productId: string
}

export function V2ProductLvdRegulationPage({
  productId,
}: V2ProductLvdRegulationPageProps) {
  return (
    <V2ProductRegulationPageShell productId={productId} law='lvd'>
      {(lvdApplies) => (
        <V2LvdLegislationBriefing
          productId={productId}
          lvdApplies={lvdApplies}
        />
      )}
    </V2ProductRegulationPageShell>
  )
}
